import React, { useState, memo } from 'react';
import CustomModal from '../CustomModal';
import './styles.scss';
import Markdown from '../Markdown';

const ve = 'Video explanation';
const VideoExplanationComponent = ({ videoLink, explanations, videoLinkLabel = ve, modalTitle = ve, tt = '' }) => {
	const [explanationsModal, setExplanationsModal] = useState(false);

	const explanationsCloseModal = () => setExplanationsModal(false);
	const explanationsOpenModal = () => setExplanationsModal(true);

	const modalContent = <Markdown>{videoLink}</Markdown>;
	const modalFooterButtons = [
		{ label: 'Close', variant: 'danger', onClick: explanationsCloseModal }
	];
	const toolTip = tt === '' ? modalTitle : tt;

	return (
		<>
			<div title={toolTip} className="btn btn-link" onClick={explanationsOpenModal}>
				<i className="fa fa-play" style={{ fontSize: '18px', color: 'blue' }}></i> {videoLinkLabel}
			</div>
			<CustomModal
				title={modalTitle}
				content={modalContent}
				footerButtons={modalFooterButtons}
				show={explanationsModal}
				handleClose={explanationsCloseModal}
				className='resource-video-modal'
			/>
		</>
	);
};

export default memo(VideoExplanationComponent);
